// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1AqJu","obliqueLineWrap":"membershipbadge_obliqueLineWrap__Xnytr","obliqueLine":"membershipbadge_obliqueLine__222Xf"};